import { gql } from 'apollo-boost';

export const fragments = {

	META_TAGS: {
		QUERY_RETURN: `name`
	},

	META_TAG: {
		QUERY_RETURN:    `name`,
		MUTATION_RETURN: `name`
	}

};

export const queries = {

	/* META TAGS COLLECTION
	* --------------------------------------------------------------------------------------------*/
	GET_META_TAGS: ( returnQueryString = fragments.META_TAGS.QUERY_RETURN ) => gql`
        query getMetaTags( $where: TagFilterInput, $order: [TagSortInput!] ) {
            tags( where: $where, order: $order ) {
                ${ returnQueryString }
            }
        }`,
};

export const mutations = {

	/*CREATE_DATA_VALUES_SET: ( returnQueryString = fragments.DATA_VALUE_SET.MUTATION_RETURN ) => gql`
	  mutation CreateDataValueSet( $input: DataValueSetCreateCommandInput! ){
	    createDataValueSet( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	UPDATE_DATA_VALUES_SET: ( returnQueryString = fragments.DATA_VALUE_SET.MUTATION_RETURN ) => gql`
	  mutation UpdateDataValueSet( $input: DataValueSetUpdateCommandInput! ){
	    updateDataValueSet( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	DELETE_DATA_VALUES_SET: () => gql`
	  mutation DeleteDataValueSet( $input: DataValueSetDeleteCommandInput! ){
	    deleteDataValueSet( input: $input )
	  }`,*/
};

export const functions = {}

export const MetaTagQueries = {
	fragments,
	queries,
	mutations,
	functions,
};
